// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/paging.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/paging.proto.
 */
export const file_proto_model_core_paging = /*@__PURE__*/
  fileDesc("Ch1wcm90by9tb2RlbC9jb3JlL3BhZ2luZy5wcm90bxIGY2FybWVuIkIKBlBhZ2luZxIRCglwYWdlX3NpemUYASABKAUSJQoKcGFnZV90b2tlbhgCIAEoCzIRLmNhcm1lbi5QYWdlVG9rZW4ikgEKEFBhZ2luYXRpb25SZXN1bHQSFQoNdG90YWxfcmVzdWx0cxgBIAEoBRITCgtwYWdlX251bWJlchgCIAEoBRIRCglwYWdlX3NpemUYAyABKAUSEwoLdG90YWxfcGFnZXMYBCABKAUSKgoPbmV4dF9wYWdlX3Rva2VuGAUgASgLMhEuY2FybWVuLlBhZ2VUb2tlbiIaCglQYWdlVG9rZW4SDQoFdG9rZW4YASABKAlCKFomZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw");

/**
 * Describes the message carmen.Paging.
 * Use `create(PagingSchema)` to create a new message.
 */
export const PagingSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_paging, 0);

/**
 * Describes the message carmen.PaginationResult.
 * Use `create(PaginationResultSchema)` to create a new message.
 */
export const PaginationResultSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_paging, 1);

/**
 * Describes the message carmen.PageToken.
 * Use `create(PageTokenSchema)` to create a new message.
 */
export const PageTokenSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_paging, 2);

